import { css } from "@emotion/react";

export const TiptapMenuCSS = css`
  .bubble-menu,
  .floating-menu {
    margin-bottom: 4px;
    border-radius: 10px;
    opacity: 1;
    min-height: 36px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: fit-content;

    > div > button + button {
      margin-left: 12px;
    }

    button:not(.link) {
      border: none;
      background: none;
      font-size: 1rem;
      align-items: center;
      display: flex;
      justify-content: center;
      color: #fff;
      font-weight: 500;
      height: 30px;
      width: 30px;
      border-radius: 4px;
      cursor: pointer;

      &:hover,
      &.is-active {
        /* opacity: 1; */
      }
    }
  }

  div[data-tippy-root] {
    transition: opacity 150ms 40ms;
  }

  .tippy-box[data-state="hidden"] {
    opacity: 0;
  }

  .bubble-menu:after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 102px;
    border-color: #fb972e transparent;
    display: block;
    z-index: 1;
    margin-bottom: 4px;
  }

  .floating-menu:after {
    content: "";
    position: absolute;
    top: -8px;
    left: 140px;
    border-color: #222 transparent;
    display: block;
    z-index: 1;
  }

  .hidden {
    opacity: 0;
    display: none;
  }

  .orange {
    background-color: #fb972e;
  }

  .black {
    background-color: #222;
  }
`;
